import { useState } from 'react';
import styled from 'styled-components';
import { Collapse } from '@material-ui/core';
import * as LighthouseService from 'common/services/lighthouse.service';
import Icon from './Icon';
import { Flex } from './layout-components';
import { LBButton } from '@linearb/buzz';

const Pointer = styled(Flex)`
  cursor: pointer;
  width: 100%;
`;

const AccordionTitle = styled(Flex)`
  ${({ stickTitle }) =>
    stickTitle
      ? `position: sticky;
top: 0;
z-index: 1000;
background-color: white;`
      : ''};
`;

const Accordion = props => {
  const {
    defaultIsOpen = false,
    children = null,
    titleComponent,
    articleId,
    CollapseIcon = ({ isOpen }) => (
      <Icon
        color='gray'
        name={isOpen ? 'ChevronLeft' : 'ChevronRight'}
        {...(isOpen ? { direction: 'right' } : {})}
      />
    ),
    timeout = 'auto',
    stickyElements = []
  } = props;
  const [isOpen, setIsOpen] = useState(defaultIsOpen);
  const Title = titleComponent;

  return (
    <div>
      <AccordionTitle direction='column' justify='space-between' {...props}>
        <Flex>
          <Pointer
            onClick={
              props.setIsOpen
                ? () => props.setIsOpen(!props.isOpen)
                : () => setIsOpen(!isOpen)
            }
            direction='row'
            items='center'
          >
            <CollapseIcon isOpen={props.isOpen || isOpen} />
            {Title}
          </Pointer>
          {articleId ? (
            <Flex items='center'>
              <LBButton
                onClick={() => LighthouseService.navigateArticle(articleId)}
                variant='ghost'
                size='icon'
              >
                <Icon name='helpicon' size='smaller' color='nepal' />
              </LBButton>
            </Flex>
          ) : null}
        </Flex>
        {stickyElements}
      </AccordionTitle>
      <Collapse
        in={props.isOpen ? props.isOpen : isOpen}
        collapsedSize='0'
        timeout={timeout}
      >
        {children}
      </Collapse>
    </div>
  );
};

export default Accordion;
